module.exports = __webpack_public_path__ + "static/media/toelogic-logo.1c79b06f.jpg";